export enum WorkPatternEnum {
  NoApplicable = 1,
  TaskOriented = 2,
  Scheduled = 3
}
